import { Field, ErrorMessage } from "formik"
import { useEffect, useState, useRef } from "react"
import ReCAPTCHA from "react-google-recaptcha"

const paises = ["Afganistán", "Albania", "Alemania", "Andorra", "Angola", "Antigua y Barbuda", "Arabia Saudita", "Argelia", "Argentina", "Armenia", "Australia", "Austria", "Azerbaiyán", "Bahamas", "Bangladés", "Barbados", "Baréin", "Bélgica", "Belice", "Benín", "Bielorrusia", "Birmania", "Bolivia", "Bosnia y Herzegovina", "Botsuana", "Brasil", "Brunéi", "Bulgaria", "Burkina Faso", "Burundi", "Bután", "Cabo Verde", "Camboya", "Camerún", "Canadá", "Catar", "Chad", "Chile", "China", "Chipre", "Ciudad del Vaticano", "Colombia", "Comoras", "Corea del Norte", "Corea del Sur", "Costa de Marfil", "Costa Rica", "Croacia", "Cuba", "Dinamarca", "Dominica", "Ecuador", "Egipto", "El Salvador", "Emiratos Árabes Unidos", "Eritrea", "Eslovaquia", "Eslovenia", "España", "Estados Unidos", "Estonia", "Etiopía", "Filipinas", "Finlandia", "Fiyi", "Francia", "Gabón", "Gambia", "Georgia", "Ghana", "Granada", "Grecia", "Guatemala", "Guyana", "Guinea", "Guinea ecuatorial", "Guinea-Bisáu", "Haití", "Honduras", "Hungría", "India", "Indonesia", "Irak", "Irán", "Irlanda", "Islandia", "Islas Marshall", "Islas Salomón", "Israel", "Italia", "Jamaica", "Japón", "Jordania", "Kazajistán", "Kenia", "Kirguistán", "Kiribati", "Kuwait", "Laos", "Lesoto", "Letonia", "Líbano", "Liberia", "Libia", "Liechtenstein", "Lituania", "Luxemburgo", "Madagascar", "Malasia", "Malaui", "Maldivas", "Malí", "Malta", "Marruecos", "Mauricio", "Mauritania", "México", "Micronesia", "Moldavia", "Mónaco", "Mongolia", "Montenegro", "Mozambique", "Namibia", "Nauru", "Nepal", "Nicaragua", "Níger", "Nigeria", "Noruega", "Nueva Zelanda", "Omán", "Países Bajos", "Pakistán", "Palaos", "Palestina", "Panamá", "Papúa Nueva Guinea", "Paraguay", "Perú", "Polonia", "Portugal", "Reino Unido", "República Centroafricana", "República Checa", "República de Macedonia", "República del Congo", "República Democrática del Congo", "República Dominicana", "República Sudafricana", "Ruanda", "Rumanía", "Rusia", "Samoa", "San Cristóbal y Nieves", "San Marino", "San Vicente y las Granadinas", "Santa Lucía", "Santo Tomé y Príncipe", "Senegal", "Serbia", "Seychelles", "Sierra Leona", "Singapur", "Siria", "Somalia", "Sri Lanka", "Suazilandia", "Sudán", "Sudán del Sur", "Suecia", "Suiza", "Surinam", "Tailandia", "Tanzania", "Tayikistán", "Timor Oriental", "Togo", "Tonga", "Trinidad y Tobago", "Túnez", "Turkmenistán", "Turquía", "Tuvalu", "Ucrania", "Uganda", "Uruguay", "Uzbekistán", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Yibuti", "Zambia", "Zimbabue"]

export default function CreditCardInputs({ setModal, values, setFieldValue, errors, touched }) {

  const [mmyy, setMMYY] = useState('')

  // const inputRef = useRef()

  const formatMMYY = (e, setFieldValue) => {
    if (e.target.value.length <= 5 && isNumber(e.target.value.slice(-1))) {
      const newChar = e.target.value.length === 2 ? e.target.value + '/' : e.target.value
      setMMYY(newChar)

      if (e.target.value.length === 5) {
        const { ok, mmyy } = esFechaValida(newChar)

        if (!ok) {
          setMMYY('')
          return setModal({
            msg: 'Fecha de vencimiento de tarjeta de credito no válida.',
            ok: false,
            show: true
          })
        }
        setFieldValue('mmyy', mmyy)
      }
    }
  }

  const handleKey = (e, setFieldValue, values) => {
    if (e.key === 'Backspace') {
      setMMYY(curr => curr.slice(0, -1))
      setFieldValue('mmyy', '')
    }
  }

  const formatCVC = (e) => {
    if (e.target.value.length < 5 && isNumber(e.target.value.slice(-1))) {
      setFieldValue('code', e.target.value)
    }
  }

  const formatCreditCard = (e) => {
    if (e.target.value.length < 20 && isNumber(e.target.value.slice(-1))) {
      setFieldValue('number', e.target.value)
    }
  }

  const validateDatosTarjeta = (value, values) => {

    let error;

    if (values.tarjeta > 0) {
      if (!value) {
        error = 'Dato obligatorio'
      }
    }

    return error

  }

  //Algoritmo para compbar si el número de tarjeta es válido
  const luhnAlgorithm = (numberStr = '') => {
    const reverseArr = numberStr.split('').reverse();
    let oddArr = reverseArr.filter((x, idx) => idx % 2).map(x => Number(x));
    const evenArr = reverseArr.filter((x, idx) => !(idx % 2)).map(x => Number(x));

    oddArr = oddArr.map(x => {
      let num = x * 2;
      if (num > 9) {
        num = String(num).split('').reduce((acc, x) => acc + Number(x), 0);
      }
      return num;
    })

    const sum = oddArr.concat(evenArr).reduce((acc, x) => acc + x, 0);

    if (sum % 10 === 0) {
      return true;
    }
  }

  const validateNumeroTarjeta = (value, values) => {

    let error;

    if (values.tarjeta > 0) {
      if (!value) {
        error = 'Dato obligatorio'
      }
    }

    const isValid = luhnAlgorithm(value);

    if (!isValid) {
      error = 'Tarjeta no válida.'
    }

    return error

  }

  const isError = (errors) => {
    const {
      IdBodega = '',
      Nit = '',
      NombreDoc = '',
      Direccion = '',
      tarjeta = '',
      efectivo = '',
      ...camposTarjeta } = errors

    const errorsTarjeta = Object.entries(camposTarjeta).reduce((acc, [key, value]) => {
      if (value) {
        acc.push(key)
      }

      return acc
    }, [])

    if (errorsTarjeta.length !== 0 || camposTarjeta.number === 'NA') {
      //console.log(errorsTarjeta)
      return {
        ok: false,
        msg: 'Ingrese todos los campos de la tarjeta de crédito / débito'
      }
    }

    return {
      ok: true
    }
  }

  const Error = isError(errors)

  useEffect(() => {
    setFieldValue("pais", 'Guatemala')
    // inputRef.current.focus()
    setFieldValue("pais", 'Guatemala')
  }, [])

  return (
    <>
      <fieldset className='col-span-6 lg:col-start-4 lg:col-span-3'>
        <div className="flex justify-between">
          <label className="block text-sm font-medium text-grisMira">
            Tarjeta de crédito / débito
          </label>
        </div>
        <div className="mt-1 -space-y-px rounded-md bg-white shadow-sm">
          <div>
            <label htmlFor="card-number" className="sr-only">
              Número de tarjeta
            </label>
            {errors.number !== 'NA' ? <ErrorMessage component="p" name="number" className="text-xs text-center font-semibold text-secundario" />
              : null}
            <Field
              // innerRef={inputRef}
              validate={(value) => validateNumeroTarjeta(value, values)}
              onChange={formatCreditCard}
              value={values.number}
              type="text"
              name="number"
              id="number"
              className="relative block w-full rounded-none rounded-t-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
              placeholder="Número de tarjeta"
            />
          </div>
          <div className="flex -space-x-px">
            <div className="w-1/2 min-w-0 flex-1">
              <ErrorMessage component="p" name="mmyy" className="text-xs text-center font-semibold text-secundario" />
              <label htmlFor="card-expiration-date" className="sr-only">
                Fecha de vencimiento
              </label>
              <Field
                validate={(value) => validateDatosTarjeta(value, values)}
                onChange={(e) => formatMMYY(e, setFieldValue)}
                onKeyDown={(e) => handleKey(e, setFieldValue, values)}
                value={mmyy}
                type="text"
                name="mmyy"
                id="mmyy"
                className="relative block w-full rounded-none rounded-bl-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                placeholder="MM / YY"
              />
            </div>
            <div className="min-w-0 flex-1">
              <label htmlFor="card-cvc" className="sr-only">
                CVC
              </label>
              <ErrorMessage component="p" name="mmyy" className="text-xs text-center font-semibold text-secundario" />
              <Field
                validate={(value) => validateDatosTarjeta(value, values)}
                onChange={formatCVC}
                value={values.code}
                type="password"
                name="code"
                id="card-cvc"
                className="relative block w-full rounded-none rounded-br-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                placeholder="CVC"
              />
            </div>
          </div>
        </div>
      </fieldset>

      <div className="col-span-6">
        <fieldset>
          <legend className="block text-sm font-medium text-grisMira">¿Donde fue emitida la tarjeta? </legend>
          <div className="mt-1 bg-white -space-y-px rounded-md shadow-sm">
            <div>
              <label htmlFor="country" className="sr-only">
                Pais
              </label>
              <ErrorMessage component="p" name="pais" className="text-xs text-center font-semibold text-secundario" />
              <Field
                validate={(value) => validateDatosTarjeta(value, values)}
                id="pais"
                name="pais"
                as='select'
                className="relative block w-full rounded-none rounded-t-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
              >
                <option value=''>-------------</option>
                {
                  paises.map((pais, key) => <option key={key} value={pais}>{pais}</option>)
                }
              </Field>
            </div>
            <div>
              <label htmlFor="direccion" className="sr-only">
                Dirección
              </label>
              <ErrorMessage component="p" name="direccion" className="text-xs text-center font-semibold text-secundario" />
              <Field
                validate={(value) => validateDatosTarjeta(value, values)}
                type="text"
                name="direccion"
                id="direccion"
                autoComplete="direccion"
                className="relative block w-full rounded-none rounded-b-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                placeholder="Dirección"
              />
            </div>
          </div>
        </fieldset>

        <p className="w-full text-sm text-right mt-1 pr-2 font-medium text-yellow-400">
          Se recomienda colocar la dirección registrada en su banco.
        </p>
      </div>

      <fieldset className='lg:row-start-2 col-span-6 lg:col-span-3'>
        <legend className="block text-sm font-medium text-grisMira">Datos del tarjetahabiente</legend>
        <div className="mt-1 -space-y-px rounded-md bg-white shadow-sm">
          <div>
            <label htmlFor="email" className="sr-only">
              Email
            </label>
            <ErrorMessage component="p" name="email" className="text-xs text-center font-semibold text-secundario" />
            <Field
              validate={(value) => validateDatosTarjeta(value, values)}
              type="email"
              name="email"
              id="email"
              className="relative block w-full rounded-none rounded-t-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
              placeholder="Correo electrónico"
            />
          </div>
          <div className="flex -space-x-px">
            <div className="w-1/2 min-w-0 flex-1">
              <label className="sr-only">
                Nombres
              </label>
              <ErrorMessage component="p" name="nombres" className="text-xs text-center font-semibold text-secundario" />
              <Field
                validate={(value) => validateDatosTarjeta(value, values)}
                autoComplete='given-name'
                type="text"
                name="nombres"
                id="nombres"
                className="relative block w-full rounded-none rounded-l-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                placeholder="Nombres"
              />
            </div>
            <div className="min-w-0 flex-1">
              <label className="sr-only">
                Apellidos
              </label>
              <ErrorMessage component="p" name="apellidos" className="text-xs text-center font-semibold text-secundario" />
              <Field
                validate={(value) => validateDatosTarjeta(value, values)}
                autoComplete='family-name'
                type="text"
                name="apellidos"
                id="apellidos"
                className="relative block w-full rounded-none rounded-r-md border-gray-300 bg-transparent focus:z-10 focus:border-secundario focus:ring-secundario sm:text-sm"
                placeholder="Apellidos"
              />
            </div>
          </div>
        </div>
      </fieldset>

      {
        !Error.ok ?
          <p className="col-span-full w-full text-center block text-lg font-semibold text-red-500">{Error.msg}</p>
          : null
      }
    </>
  )
}

const isNumber = (x) => {
  const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
  return numbers.some(y => y === Number(x))
}

const esFechaValida = (mmyy) => {
  const d = new Date()
  const currentMonth = d.getMonth() + 1
  const currentYear = d.getFullYear()

  let [month, year] = mmyy.split('/')
  month = Number(month)
  year = Number('20' + year)

  if (year > currentYear && month <= 12) {
    return {
      ok: true,
      mmyy
    }
  } else if (year === currentYear && month >= currentMonth && month <= 12) {
    return {
      ok: true,
      mmyy
    }
  } else {
    return {
      ok: false
    }
  }
}
